import { render, staticRenderFns } from "./bf-translate.vue?vue&type=template&id=24074ed0&scoped=true&lang=pug&"
import script from "./bf-translate.vue?vue&type=script&lang=js&"
export * from "./bf-translate.vue?vue&type=script&lang=js&"
import style0 from "./bf-translate.vue?vue&type=style&index=0&id=24074ed0&scoped=true&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24074ed0",
  null
  
)

export default component.exports